function initContactForm() {
  const successMessageUrl = `${window.location.pathname}?section_id=form-message`;

  function getQueryString() {
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');
    const result = {};

    for (let i = 0; i < params.length; i++) {
      const pair = params[i].split('=');
      result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }

    return result;
  }

  function getMessageFromSettings() {
    if (getQueryString()['contact[tags]']) {
      const Id = window.location.hash.split('#')[1];
      const newsLetterForm = document.querySelector("[data-id='" + Id + "']");

      if (newsLetterForm) {
        if (newsLetterForm.querySelector('form-error')) {
          const errorMessage = newsLetterForm.querySelector('form-error').textContent;
          return errorMessage;
        } else {
          const message = newsLetterForm.dataset.errorMessage;
          if (message) {
            return message;
          }
        }
      }
    } else {
      if (getQueryString()['customer_posted'] === 'true') {
        const Id = window.location.hash.split('#')[1];

        const newsLetterForm = document.querySelector("[data-id='" + Id + "']");
        if (newsLetterForm) {
          const message = newsLetterForm.dataset.successMessage;

          if (message) {
            return message;
          }
        }
      }
    }
  }

  function showToast(message) {
    new Debutify.toast(message, {
      position: 'top-right',
      duration: '100000',
      closeIcon: 'close',
      colorScheme: 'color-scheme-2',
      className: 'contactFormToast',
    });
  }

  function handleSuccessMessage() {
    fetch(successMessageUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const successMessageElement = html.querySelector('.contact-form__success-message-wrapper');

        let message = getMessageFromSettings('success');
        const messageElement = successMessageElement.querySelector('.form__message_show');

        if (message === undefined) return;

        if (messageElement) {
          messageElement.innerHTML = message;
        }
        showToast(successMessageElement.innerHTML);
      })
      .catch((error) => {
        console.error('Error fetching success message:', error);
      });
  }

  function handleErrorMessage() {
    fetch(successMessageUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const errorMessageElement = html.querySelector('.contact-form__error-message-wrapper');

        let message = getMessageFromSettings('error');
        const messageElement = errorMessageElement.querySelector('.form__message_show');

        if (messageElement) {
          messageElement.innerHTML = message;
        }
        showToast(errorMessageElement.innerHTML);
      })
      .catch((error) => {
        console.error('Error fetching error message:', error);
      });
  }

  function checkUrlReturn() {
    const currentUrl = window.location.href;

    if (currentUrl.includes('newsletter_id_')) {
      clearUrlParams();
      return;
    }

    if (
      currentUrl.includes('customer_posted=true') ||
      currentUrl.includes('contact_posted=true#back_in_stock_contact')
    ) {
      handleSuccessMessage();
      clearUrlParams();
    } else if (currentUrl.includes('%5Btags%5D=')) {
      handleErrorMessage();
      clearUrlParams();
    }
  }

  function clearUrlParams() {
    setTimeout(() => {
      const newURL = location.href.split('?')[0];
      window.history.pushState('object', document.title, newURL);
    }, 1000);
  }

  checkUrlReturn();
}

initContactForm();
